import type {
	Business,
	BusinessQuery
} from '@/modules/dashboard/dashboardTypes';
import type { AiSearchSchemaProps } from '@/schemas/aiSearch/schema';
import type { HttpResponseSuccess } from './service';
import service from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export type GetAiSearchProps = AiSearchSchemaProps;

export type HttpGetAiSearchResponse = {
	businesses: Array<Business>;
	cursor: [number];
	count: number;
	filters: BusinessQuery;
};

export const getAiSearch = ({
	filters
}: GetAiSearchProps): Promise<HttpResponseSuccess<HttpGetAiSearchResponse>> =>
	apiService.get('/api/businesses/ai/search', { params: { query: filters } });
